import { Box, Chip } from '@mui/material';

interface AddedCitiesListProps {
  addedCities: string[];
  setAddedCities: (val: string[]) => void;
}

export const AddedCitiesList = ({
  addedCities,
  setAddedCities,
}: AddedCitiesListProps) => {
  return (
    <Box className="cities">
      {addedCities.map((city, i) => {
        return (
          <Box className="field" key={i}>
            <Chip
              sx={{ backgroundColor: 'white' }}
              label={city}
              variant="outlined"
              onDelete={() => {
                setAddedCities(addedCities.filter((c) => c !== city));
              }}
            />{' '}
          </Box>
        );
      })}
    </Box>
  );
};
